import http from 'hub-http/clients/apiClient';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import I18n from 'I18n';
import { logRavenException } from '../../../utils/ravenWrapperUtil';
const CREATE_FORECAST_TYPE_URI = '/forecasting/v1/settings/forecast-type';
const DEFAULT_FORECAST_TYPE_VALUES = {
  objectTypeId: '0-3'
};
export const createForecastType = forecastType => {
  const data = Object.assign({}, DEFAULT_FORECAST_TYPE_VALUES, forecastType);
  return http.post(CREATE_FORECAST_TYPE_URI, {
    data
  }).catch(error => {
    logRavenException(error, 'create forecast type failed', {
      forecastType
    });
    FloatingAlertStore.addAlert({
      message: I18n.text('createForecastTypeWizard.createForecastError'),
      titleText: I18n.text('createForecastTypeWizard.createForecastErrorTitle'),
      type: 'danger'
    });
    return {
      error: true
    };
  });
};